function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#F26739",
  points: "10.6,28.8 11,26.1 6.4,23.5 1,17.9 0.4,13.8 3.7,10.2 6.9,9.6 11.7,11.5 16,9.6 20.7,11.1 22.7,13.3  22.9,16.9 20.4,20.8 14.7,24.4 14.5,27  "
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  fill: "#FFFFFF",
  cx: 8,
  cy: 14.9,
  rx: 2.1,
  ry: 2.5
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  fill: "#FFFFFF",
  cx: 16,
  cy: 14.9,
  rx: 2.1,
  ry: 2.5
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#999999",
  points: "11.7,11.2 9.8,9.9 5.9,2.9 6.7,2.7 10.6,5.6 11.8,0.5 13.1,5.5 17,2.4 17.3,3.4 13.8,10  "
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16,17.7c1.3,0,2.3-1.2,2.3-2.8s-1-2.8-2.3-2.8s-2.3,1.2-2.3,2.8 S14.7,17.7,16,17.7z M16,17.2c-1,0-1.8-1-1.8-2.3s0.8-2.3,1.8-2.3s1.8,1,1.8,2.3S17,17.2,16,17.2z M16,16.5c0.6,0,1-0.7,1-1.5 c0-0.8-0.4-1.5-1-1.5s-1,0.7-1,1.5C15,15.8,15.4,16.5,16,16.5z M8,17.7c1.3,0,2.3-1.2,2.3-2.8s-1-2.8-2.3-2.8S5.8,13.4,5.8,15 S6.7,17.7,8,17.7z M8,17.2c-1,0-1.8-1-1.8-2.3S7,12.7,8,12.7s1.8,1,1.8,2.3S9,17.2,8,17.2z M8,16.5c0.6,0,1-0.7,1-1.5 c0-0.8-0.4-1.5-1-1.5S7,14.1,7,15C7,15.8,7.4,16.5,8,16.5z M10.4,21.7c0-0.1,0.2-0.2,0.4-0.4c0.3-0.2,0.7-0.4,1.2-0.4 c0.5,0,0.9,0.1,1.2,0.4c0.2,0.1,0.3,0.3,0.4,0.4c0.1,0.2,0.5,0.3,0.7,0.2c0.2-0.1,0.3-0.5,0.2-0.7c-0.1-0.2-0.3-0.4-0.6-0.6 C13.3,20.2,12.7,20,12,20c-0.7,0-1.3,0.2-1.8,0.6c-0.3,0.2-0.5,0.5-0.6,0.6c-0.1,0.2-0.1,0.5,0.2,0.7C10,22,10.3,22,10.4,21.7z"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-188.000000, -335.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(192.000000, 336.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.7,10.9c2.6,0,6.1-8.1,6.2-9.5c0-0.3-0.3-0.6-0.6-0.5c-0.5,0.1-1,0.3-1.5,0.7c-0.5,0.3-1,0.7-1.5,1.2 C9.8,3.2,9.4,3.6,9.4,3.6s-0.1-1.3-0.2-2C9,0.6,8.7-0.2,8.2-0.8c-0.2-0.3-0.6-0.3-0.8,0C7-0.2,6.7,0.6,6.4,1.6 C6.3,2.3,6.1,3.8,6.1,3.8S5.4,3.1,4.9,2.7c-0.5-0.4-1-0.8-1.5-1.2C3,1.2,2.5,1,2.2,0.9C1.8,0.7,1.4,1,1.5,1.4 C1.9,4,5.9,10.9,7.7,10.9z M2.9,2.4C3.3,2.6,3.8,3,4.3,3.4c0.5,0.4,0.9,0.8,1.4,1.3C5.9,5,6.1,5.2,6.2,5.3 c0.3,0.3,0.9,0.1,0.9-0.3c0-0.9,0.1-2,0.3-3.1C7.6,1,7.8,0.6,7.8,0.6s0.2,0.7,0.3,1.2c0.2,1,0.2,3.1,0.2,3.1 c0,0.5,0.6,0.7,0.9,0.3c0.1-0.1,0.2-0.3,0.5-0.5c0.4-0.4,0.8-0.8,1.2-1.2c0.5-0.5,0.9-0.8,1.4-1.1c0.4-0.3,0.4-0.3,0.4-0.3 c-0.7,2.6-3.9,7.8-5,7.8C6.5,9.9,3.3,4,2.9,2.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.4,10c0.1,0.1,1,0.6,1.2,0.7C7.1,10.9,7.4,11,7.7,11c0.3,0,0.6-0.1,1.1-0.4C9.1,10.5,9.9,10,10,10 c0.9-0.5,1.9-0.9,2.7-0.9c3,0,5.7,2.6,5.7,5.1c0,3.4-3.1,6.3-8,9c-0.4,0.2-0.5,0.6-0.5,1.5c0,0.1,0.1,0.8-0.1,1 c-0.1,0.1-0.3,0.2-0.8,0.3C8.6,26,8,26.1,7,26.8c0.1-0.6,0.6-1,0.5-1.6c0-0.6-0.4-0.9-1-1.3c-0.2-0.1-0.7-0.3-0.7-0.3 C0.6,21-3,17.7-3,14.2c0-2.5,2.7-5.1,5.7-5.1C3.7,9.1,4.4,9.4,5.4,10z M-4,14.2c0,4.1,3.9,7.6,9.4,10.3c0,0,0.9,0.4,1.2,0.7 c0,0.1,0,0-0.2,0.5c-0.4,0.8-0.5,1.5-0.1,2.5c0.2,0.4,0.8,0.4,0.9,0c0.3-0.6,0.7-1,1.4-1.2C8.8,27,8.8,27,9.3,26.9 c0.7-0.2,1.1-0.3,1.3-0.6c0.3-0.3,0.4-0.8,0.4-1.5c0-0.1,0-0.9-0.1-0.8c5.1-2.7,8.5-6,8.5-9.9c0-3.1-3.2-6.1-6.7-6.1 c-0.1,0-0.1,0-0.2,0c-0.9,0-1.8,0.4-3,1c-0.1,0.1-1,0.6-1.2,0.7C8,9.9,7.8,10,7.7,10c-0.1,0-0.3-0.1-0.6-0.2 C6.9,9.6,6,9.2,5.9,9.1C4.8,8.5,4,8.2,3.1,8.1c-0.1,0-0.2,0-0.4,0C-0.8,8.1-4,11.1-4,14.2z"
})));

var SvgSadTurnip = function SvgSadTurnip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.5 29.6",
    style: {
      enableBackground: "new 0 0 23.5 29.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSadTurnip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sad-turnip.0a426eac.svg";
export { ForwardRef as ReactComponent };